import { useQuery, gql } from '@apollo/client';
export const UserQuery = ("__gql__", "{\"kind\":\"Document\",\"definitions\":[{\"kind\":\"OperationDefinition\",\"operation\":\"query\",\"name\":{\"kind\":\"Name\",\"value\":\"BulkActionsUserQuery\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"viewer\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"ownerId\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"hubSpotUser\"},\"selectionSet\":{\"kind\":\"SelectionSet\",\"selections\":[{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"email\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"firstName\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"lastName\"}},{\"kind\":\"Field\",\"name\":{\"kind\":\"Name\",\"value\":\"userId\"}}]}}]}}]}}]}", {
  id: null,
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "BulkActionsUserQuery"
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "viewer"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "ownerId"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "hubSpotUser"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "email"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "firstName"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "lastName"
                }
              }, {
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "userId"
                }
              }]
            }
          }]
        }
      }]
    }
  }]
});
export const useUserInfo = () => {
  const {
    data,
    loading,
    error
  } = useQuery(UserQuery);
  const hasFetchedData = !loading && !error && !!data;
  return {
    email: hasFetchedData ? data.viewer.hubSpotUser.email : null,
    firstName: hasFetchedData ? data.viewer.hubSpotUser.firstName : null,
    lastName: hasFetchedData ? data.viewer.hubSpotUser.lastName : null,
    ownerId: hasFetchedData ? data.viewer.ownerId : null,
    userId: hasFetchedData ? data.viewer.hubSpotUser.userId : null
  };
};